import { useIntl } from "react-intl";

export const SearchEmpty = () => {
  const intl = useIntl();
  return (
    <p className="text-base-foreground text-sm font-medium py-3">
      {intl.formatMessage({
        id: "search.empty",
        defaultMessage: "No results found",
      })}
    </p>
  );
};
